import { NavLink } from 'react-router-dom';
import { Gauge, AlertOctagon, BellRing, Receipt, TrendingUp, Settings as SettingsIcon } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useLanguage } from '@/hooks/useLanguage';

const ITEMS = [
  { to: '/',           label: 'Power',      icon: Gauge         },
  { to: '/anomaly',    label: 'Anomaly',    icon: AlertOctagon  },
  { to: '/efficiency', label: 'Efficiency', icon: TrendingUp    },
  { to: '/billing',    label: 'Billing',    icon: Receipt       },
  { to: '/alerts',     label: 'Alerts',     icon: BellRing      },
  { to: '/settings',   label: 'Settings',   icon: SettingsIcon  },
] as const;

export function BottomNav() {
  const { t } = useLanguage();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 bg-white/92 backdrop-blur-2xl border-t border-ink-100/80 pad-safe-bottom"
      aria-label="Primary navigation">
      <ul className="grid grid-cols-6 max-w-screen-md mx-auto">
        {ITEMS.map(({ to, label, icon: Icon }) => (
          <li key={to}>
            <NavLink to={to} end={to === '/'}
              className={({ isActive }) => cn(
                'relative flex flex-col items-center justify-center gap-0.5',
                'min-h-[56px] py-2 px-1 text-[10px] font-semibold tracking-tight text-center leading-tight transition-colors duration-150',
                isActive ? 'text-brand-600' : 'text-ink-400',
              )}>
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute top-1.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-brand-500" />}
                  <span className={cn('flex items-center justify-center w-9 h-8 rounded-xl transition-all duration-150',
                    isActive ? 'bg-brand-50' : 'bg-transparent')}>
                    <Icon className="w-[18px] h-[18px] transition-all duration-150" strokeWidth={isActive ? 2.5 : 1.75} />
                  </span>
                  <span className={cn('transition-all duration-150 text-[9px] sm:text-[10px]',
                    isActive ? 'text-brand-600 font-bold' : 'text-ink-400')}>{t(label)}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
